import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './components/HeroSection';
import CommonlyTreated from './components/PhysicalTherapy';
import SpeechTherapy from './components/SpeechTherapy';
import OccupationalTherapy from './components/OccupationalTherapy';

const TherapiesServices = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>
          Pediatric Therapy Services Wasilla Alaska | Guidepost Therapies
        </title>
        <meta
          name="description"
          content="Comprehensive pediatric therapy services in Wasilla, Alaska including physical therapy, occupational therapy, and speech therapy. Helping children reach their full potential."
        />
        <meta
          name="keywords"
          content="pediatric therapy services Wasilla, therapy services Alaska, PT OT SLP Wasilla, pediatric therapies Alaska"
        />
      </Helmet>
      <HeroSection />
      <CommonlyTreated />
      <SpeechTherapy />
      <OccupationalTherapy />
    </div>
  );
};

export default TherapiesServices;
